import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import CompanyPanelGroupComponent from '../../../components/profile/Companies/CompanyPanelGroupComponent';
import ModalComponent from '../../core/ModalComponent/ModalComponent';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';
import CompanyFormContainer from '../../../containers/CompanyFormContainer';

import './companies.scss';

const _ = require('lodash');

const ACTIONS = {
    add: 'add',
    edit: 'edit',
};

class CompaniesComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalTitle: '',
            modalMessage: '',
            modalBody: '',
            modalConfirmButtonTitle: 'Yes',
            modalCancelButtonTitle: 'No',
            modalOnConfirm: () => {},
            showModal: false,
            activeKey: this.props.activePanel,
        };

        this.showModal = this.showModal.bind(this);
    }

    showModal = (action, company) => {
        let state = {};

        ReactGA.event({
            category: 'Companies Component',
            action: 'Clicked Add Icon',
            label: 'Icon',
        });

        if (action === ACTIONS.add) {
            state = {
                modalTitle: `${_.capitalize(action)} Company`,
                modalBody: this.renderCreateForm(company),
                modalConfirmButtonTitle: 'Create',
                modalCancelButtonTitle: 'Cancel',
                modalOnConfirm: this.props.submitCompanyForm,
                disableConfirmButton: true,
            };
        } else {
            if (!company.companySize) {
                company.companySize = company.size;
            }
            state = {
                action: ACTIONS.edit,
                modalTitle: 'Edit Company',
                modalBody: this.renderCreateForm(company),
                modalConfirmButtonTitle: 'Update',
                modalCancelButtonTitle: 'Cancel',
                modalOnConfirm: this.props.submitCompanyForm,
                disableConfirmButton: false,
            };
        }

        this.setState({
            ...state,
            showModal: true,
        });
    }

    closeModal = () => {
        ReactGA.event({
            category: 'Companies Component',
            action: 'Clicked Close Modal Icon',
            label: 'Icon',
        });

        this.setState({
            showModal: false,
        });
    }

    updateInvalid = (invalid) => {
        this.setState({
            disableConfirmButton: invalid,
        });
    }

    renderCreateForm = (company) => <CompanyFormContainer
        company={company}
        initialValues={company}
        close={this.closeModal}
        updateInvalid={this.updateInvalid}
    />;

    handleSelect = (activeKey) => {
        this.setState({ activeKey });
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Companies Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const {
            isLoading,
            companies,
            viewLicenses,
            user,
        } = this.props;
        const {
            activeKey,
            showModal,
            modalTitle,
            modalBody,
            disableConfirmButton,
            modalConfirmButtonTitle,
            modalCancelButtonTitle,
            modalOnConfirm,
        } = this.state;

        return <div>
            {isLoading && <LoadingComponent fullScreen />}
            <div className="companies-component">
                <h3>Companies</h3>
                <span className="link" onClick={() => this.showModal(ACTIONS.add)}>
                    Add
                </span>
                <div>
                    {(Object.keys(user).length > 0) && <CompanyPanelGroupComponent
                        activeKey={activeKey}
                        handleSelect={this.handleSelect}
                        companies={companies}
                        onEdit={this.showModal}
                        viewLicenses={viewLicenses}
                        user={user}
                    />}
                </div>
            </div>
            <ModalComponent
                show={showModal}
                handleClose={this.closeModal}
                title={modalTitle}
                body={modalBody}
                cancelButtonTitle={modalCancelButtonTitle}
                confirmButtonTitle={modalConfirmButtonTitle}
                disableConfirmButton={disableConfirmButton}
                onConfirm={modalOnConfirm}
            />
        </div>;
    }
};

CompaniesComponent.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    activePanel: PropTypes.string,
    companies: PropTypes.array.isRequired,
    submitCompanyForm: PropTypes.func.isRequired,
    viewLicenses: PropTypes.func.isRequired,
    user: PropTypes.isRequired,
};

export default CompaniesComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Companies/CompaniesComponent.js